// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const WifiFilled = createIcon(
  <path d="M11.1869 18.1308C11.5967 18.5405 12.261 18.5405 12.6707 18.1308L20.6955 10.106C21.1099 9.69164 21.1062 9.01399 20.6546 8.6405C15.6312 4.48636 8.2998 4.537 3.33295 8.79312C2.89293 9.17017 2.89478 9.83866 3.30453 10.2484L11.1869 18.1308Z" />,
);
